import service from "@/api/request";
export const getPermission = (id) => service.getByQuery(`/courseAdmin/adminUser/auth?userId=${id}`);
export const requestLogout = () => service.getByQuery("/courseAdmin/logout");
export const getUserList = (id, pageNo) => service.getByQuery(`/courseAdmin/user/userCourseList?searchContent=${id}&pageNo=${pageNo}`);
export const deleteUser = (id) => service.getByQuery(`/courseAdmin/user/deleteUser?userId=${id}`);
export const getUserCourseList = (id, pageNo) => service.getByQuery(`/courseAdmin/user/userCourseInfoList?userId=${id}&pageNo=${pageNo}`);
export const saveUserCourse = (id, courseIds) => service.postByQs(`/courseAdmin/user/saveUserCourse?userId=${id}`, {
    courseIds,
});
export const deleteUserCourse = (id) => service.getByQuery(`/courseAdmin/user/deleteUserCourse?id=${id}`);
export const updateCourseCount = () => service.getByQuery("/courseAdmin/user/updateCourseStudyCount");
export const importUser = (file, type = 1, { token, ssoId }) => {
    const data = new FormData();
    data.append("zt_token", token);
    data.append("file", file);
    data.append("type", String(type));
    return service.postByForm("/courseAdmin/user/importUserCourse", data, {
        sso_sessionid: ssoId,
    });
};
